"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitAssessmentRequest = void 0;
var SubmitAssessmentRequest = /** @class */ (function () {
    function SubmitAssessmentRequest() {
    }
    return SubmitAssessmentRequest;
}());
exports.SubmitAssessmentRequest = SubmitAssessmentRequest;
;
//# sourceMappingURL=submitAssessment.request.js.map